import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('CATEGORY_ROOT_CHIDRENS').plugin(axiosPlugin);
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchCategoryRoot = (categoryIdSlug,query = {}) => fetchAction(`/categories/${categoryIdSlug}?${queryString.stringify(query)}`);
export const resetCategoryRoot = () => redux.actions.reset();

export const categoryRoot = redux.reducer();
